import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch";
import { BotoesAcoes } from "../styles";
import SettingsIcon from "@mui/icons-material/Settings";
import { Assinatura } from "../interfaces/Assinatura";
import { getMenuItems } from "../constants/itemsActionColumns";

export const Columns = (
  onClick: (e: any) => void,
  setStatus: (status: string) => void,
  setCotaUsuarioId: (id: number | null) => void,
  setAssinaturaId: (id: number) => void,
  setPessoaId: (id: number | null) => void
): ColumnsType<Assinatura> => {
  const items = getMenuItems();

  return [
    {
      title: "Nome Usuario",
      dataIndex: "nomeUsuario",
      key: "nomeUsuario",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "nomeUsuario" }),
    },
    {
      title: "Nome Empreendimento",
      dataIndex: "nomeEmpreendimento",
      key: "nomeEmpreendimento",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "nomeEmpreendimento" }),
    },
    {
      title: "N° Apartamento",
      dataIndex: "numeroApto",
      key: "numeroApto",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "numeroApto" }),
    },
    {
      title: "Data Criacao",
      dataIndex: "created_at",
      key: "created_at",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "created_at" }),
    },
    {
      title: "Data Inicio Assinatura",
      dataIndex: "dataAssinatura",
      key: "dataAssinatura",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "dataAssinatura" }),
    },
    {
      title: "Data Vencimento",
      dataIndex: "dataVencimento",
      key: "dataVencimento",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "dataVencimento" }),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "30%",
      ...ColumnSearch<Assinatura>({ dataIndex: "status" }),
    },
    {
      title: "Acoes",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      render: (_item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setAssinaturaId(row.key);
                setStatus(row.status);
                setCotaUsuarioId(row.cotasUsuariosId);
                setPessoaId(row.pessoaId);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
